import React from 'react'

export const Page404 = () => {
    return (
        <div>
            Página 404
        </div>
    )
}